import React from 'react';
import { HookArsenalLanding } from './pages/HookArsenalLanding';
export function App() {
  return <HookArsenalLanding data-id="element-0" />;
}